module.exports = __webpack_public_path__ + "static/media/default.d874068d.png";